import type { Thing, WithContext } from 'schema-dts';

export type StructuredSchema = Thing | WithContext<Thing>;

export const serializeStructuredSchema = (thing: StructuredSchema) => `<script type="application/ld+json">${JSON.stringify(thing, null, 2)}</script>`;
